<template>
  <div id="scroll" @mousewheel="scrollout">
    <!-- 遮罩 -->

    <main v-if="isproblem" class="site-content" role="main">
      <div class="info-img">
        <img src="/static/img/info_01.png" alt style="width: 100%; height: auto;" />
      </div>
      <!-- <div class="info-img cloudsystem-wrap" style="position: relative;">
        <img src="/static/img/cloudsystem.png" alt />
        <a class="login-btn"  href="https://saas.usoftchina.com/"></a>
      </div> -->


      <!--Home Slider==================================== -->
      <!-- <div>
        <div class="slider-1">
          <img src="/static/img/banner-new.png" alt />
          <div class="slider-text-carousel">
            <el-carousel :interval="5000" arrow="never" height="23vh">
                <el-carousel-item>
                  <p>产业互联网综合服务平台</p>
                  <p>企业管理云系统</p>
                  <p>让生意不再难 令管理更简单</p>
                </el-carousel-item>
                <el-carousel-item>
                  <el-row :gutter="20" type="flex" justify="center">
                    <el-col :span="4">
                      <p>年销售额</p>
                      <p>500万以下</p>
                      <p>免费使用</p>
                    </el-col>
                    <el-col :span="4">
                      <p>年销售额</p>
                      <p>5百-2千万</p>
                      <p>2400元/年</p>
                    </el-col>
                    <el-col :span="4">
                      <p>年销售额：2千万-1亿</p>
                      <p>贸易版：9000元/年</p>
                      <p>制造版：18000元/年</p>
                    </el-col>
                    <el-col :span="4">
                      <p>年销售额：1亿以上</p>
                      <p>贸易版：18000元/年</p>
                      <p>制造版：36000元/年</p>
                    </el-col>
                  </el-row>
                </el-carousel-item>
                <el-carousel-item>
                  <el-row :gutter="20" type="flex" justify="center">
                    <el-col :span="6">
                      <p>高效精益的批流程</p>
                    </el-col>
                    <el-col :span="6">
                      <p>智能计算交货周期</p>
                    </el-col>
                    <el-col :span="6">
                      <p>实时掌握客户商机</p>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20" type="flex" justify="center" style="margin-top:20px">
                    <el-col :span="8">
                      <p>大数据过滤企业财务风险</p>
                    </el-col>
                    <el-col :span="8">
                      <p>云存储自动备份安全有保障</p>
                    </el-col>
                  </el-row>
                </el-carousel-item>
                <el-carousel-item>
                  <el-row :gutter="20" type="flex" justify="center">
                    <el-col :span="8">
                      <p>操作简单 学习容易 一点就会</p>
                    </el-col>
                    <el-col :span="8">
                      <p>管理前置 任务驱动 老板好帮手</p>
                    </el-col>
                  </el-row>
                  <p style="margin-top:20px">连通企业微信、税所、发票等多种接口</p>
                </el-carousel-item>
              </el-carousel>
          </div>
        </div>
      </div>
      <div class="product">
        <div class="pro-title">
          <p>我们的产品</p>
          <p>Our products</p>
        </div>
        <div class="product-box">
          <div class="product-top">
            <ul>
              <li>
                <div class="imgbox">
                  <img src="/static/img/maoyiyun1.png" alt />
                </div>
              </li>
              <li class="name">贸&ensp;易&ensp;云</li>
            </ul>
            <ul>
              <li>
                <div class="imgbox">
                  <img src="/static/img/zhizhaoyun1.png" alt />
                </div>
              </li>
              <li class="name">制&ensp;造&ensp;云</li>
            </ul>
          </div>
          <div class="product-bottom">
            <ul @mouseenter="enter('tradecloud')" @mouseleave="leave('tradecloud')">
              <li>销售管理</li>
              <li>采购管理</li>
              <li>库存管理</li>
              <li>应收管理</li>
              <li>应付管理</li>
              <li>财务管理</li>
              <li>行政人事</li>
              <li v-if="!tradebtn">......</li>
              <li v-else>
                <span class="reg" @click="register('trade')">立即注册</span>
              </li>
            </ul>
            <ul @mouseenter="enter('makeclound')" @mouseleave="leave('makeclound')">
              <li>进销存管理</li>
              <li>生产管理</li>
              <li>MRP物料需求</li>
              <li>应收应付</li>
              <li>成本管理</li>
              <li>财务会计</li>
              <li>行政人事</li>
              <li v-if="!makebtn">......</li>
              <li v-else>
                <span class="reg" @click="register('make')">立即注册</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="bottomimg">
        <img src="/static/img/Waves.png" alt />
      </div> -->
      <!-- End Home SliderEnd==================================== -->

      <!-- 特色 -->
      <!-- <section id="feature" ref="feature">
        <div class="container ts-worp">
          <div class="section-title text-center" style="margin-bottom: 50px">
            <p class="ts-title">我们的特色</p>
            <p class="ts-text">云端部署 &nbsp;&nbsp; 轻量应用</p>
      </div>-->
      <!-- 1 -->
      <!-- <div class="ts-box">
            <div>
              <img class="left animate1" src="/static/img/feature/for2x.png" alt="">
            </div>
            <div>
              <img class="right animate1" src="/static/img/feature/onemin2x.png" alt="">
            </div>
      </div>-->
      <!-- 2 -->
      <!-- <div class="ts-box ts-boxtow">
            <div>
              <img class="left animate2" src="/static/img/feature/towmin2x.png" alt="">
            </div>
            <div>
              <img class="right animate2" style="margin-right:20px; width:80%" src="/static/img/feature/three2x.png" alt="">
            </div>
      </div>-->
      <!-- 3 -->
      <!-- <div class="ts-box" style="padding-bottom:0px">
            <div>
              <img class="left animate3" style="width:88%" src="/static/img/feature/one2x.png" alt="">
            </div>
            <div>
              <img class="right animate3-2" style="margin-top:-30%;" src="/static/img/feature/threemin2x.png" alt="">
            </div>
      </div>-->
      <!-- 4 -->
      <!-- <div class="ts-box ts-boxtow ts-forbox" style="padding-bottom:0px">
            <div>
              <img class="left animate4-1" style="margin-top:-39%;" src="/static/img/feature/formin2x.png" alt="">
            </div>
            <div>
              <img class="right animate4" style="margin-right:30px;" src="/static/img/feature/tow2x.png" alt="">
            </div>
          </div>
        </div>
      </section>-->

      <!-- Service section 功能-->
      <!-- <section id="service" style="padding-top: 0px;margin-top:-100px">
        <div class="container" style="position: relative;">
          <img class="gn-beijing" src="/static/img/gongneng/xu xian@3x.png" alt="">
          <div class="row">
            <div class="section-title text-center" style="margin-bottom: 80px;">
              <p class="ts-title">我们的功能</p>
              <p class="ts-text">简易SCM+内部协同+外部连接</p>
            </div>
      <div class="gn-hei">-->
      <!-- <div class="col-md-3 col-sm-6 col-xs-12"> -->
      <!-- <div class="col-md-3 col-sm-3 col-xs-3">
                <div class="service-item">
                  <p class="gn-text gn-color">任务管理</p>
                  <p>任务分配，高效工作</p>
                  <p>管好每一件事</p>
                  <div class="gn-img">
                    <img src="/static/img/gongneng/ren wu 1@3x.png" alt="">
                  </div>
                </div>
              </div>
              <div class="col-md-3 col-sm-3 col-xs-3">
                <div class="service-item">
                  <p class="gn-text">资源管理</p>
                  <p>一键查询，海量供应商产品信息</p>
                  <p>节约时间</p>
                  <div class="gn-img gn-huise">
                    <img src="/static/img/gongneng/zi yuan 2@3x.png" alt="">
                  </div>
                </div>
              </div>
              <div class="col-md-3 col-sm-3 col-xs-3">
                <div class="service-item">
                  <p class="gn-text">销售管理</p>
                  <p>快速制单</p>
                  <p>利润实时算</p>
                  <div class="gn-img">
                    <img src="/static/img/gongneng/ xiao shou 3@3x.png" alt="">
                    <div class="gn-xiaoqiu"></div>
                  </div>
                </div>
              </div>
              <div class="col-md-3 col-sm-3 col-xs-3">
                <div class="service-item">
                  <p class="gn-text">采购管理</p>
                  <p>寻源.定价.采购</p>
                  <p>一条流程</p>
                  <div class="gn-img gn-huise">
                    <img src="/static/img/gongneng/cai gou 4@3x.png" alt="">
                  </div>
                </div>
              </div>
              <div class="col-md-3 col-sm-3 col-xs-3">
                <div class="service-item">
                  <div class="gn-img gn-huise">
                    <img src="/static/img/gongneng/cang ku 5@3x.png" alt="">
                    <div class="gn-xiaoqiu"></div>
                  </div>
                  <p class="gn-text">仓库管理</p>
                  <p>库存盘点，库存账龄</p>
                  <p>呆滞分析</p>
                </div>
      </div>-->
      <!-- <div class="col-md-3 col-sm-3 col-xs-3">
                <div class="service-item">
                  <div class="gn-img">
                    <img src="/static/img/gongneng/jia gong 6@3x.png" alt="">
                  </div>
                  <p class="gn-text">加工管理</p>
                  <p>BOM成本及时看</p>
                  <p>加工单自动出入库作业</p>
                </div>
              </div>
              <div class="col-md-3 col-sm-3 col-xs-3">
                <div class="service-item">
                  <div class="gn-img gn-huise">
                    <img src="/static/img/gongneng/QIAN BAO 7@3x.png" alt="">
                  </div>
                  <p class="gn-text">资金管理</p>
                  <p>清晰核算</p>
                  <p>实时查看供应商和客户账款情况</p>
                </div>
              </div>
              <div class="col-md-3 col-sm-3 col-xs-3">
                <div class="service-item">
                  <div class="gn-img">
                    <img src="/static/img/gongneng/FEN XI 8@3x.png" alt="">
                    <div class="gn-xiaoqiu gn-left"></div>
                  </div>
                  <p class="gn-text gn-color">智能分析</p>
                  <p>直观数据看板，看库存分析</p>
                  <p>收款分析，付款分析</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>-->
      <!-- end Service section -->
      <!-- 下载 -->
      <!-- <section id="download">
        <div class="container ts-worp" style="padding-top: 30px;">
          <div class="section-title text-center" style="margin-bottom: 50px">
            <p class="ts-title">下载</p>
            <p class="ts-text">下载云系统客户端</p>
          </div>
          <div class="download-conenter">
            <div class="download-box over">
              <div class="left download-box-shang">
                <img style="width:200px" src="/static/img/weiruan.png" alt="">
              </div>
              <div class="right download-box-xia">
                <div>
                  <p class="download-title">云系统PC版</p>
                  <p>适用于Windows</p>
                  <button class="download-btn" @click="downloadOne">立即下载</button>
                </div>
              </div>
            </div>
          </div>
          <div><img style="width:100%" src="/static/img/Waves.png" alt=""></div>
        </div>
      </section>-->
    </main>
    <problem v-else></problem>
  </div>
</template>

<script>
import Session from "@/utils/session";
import { setTimeout, setInterval, clearInterval } from "timers";
import problem from "../conenter/problem.vue";

export default {
  data() {
    return {
      isLogin: false, //已改用vuex控制该属性
      isRegister: false,
      account: null,
      isproblem: true, //常见问题
      isfeature: this.$route.params.isfeature,
      timer: null,
      tradebtn: false,
      financialbtn: false,
      makebtn: false
    };
  },
  components: {
    problem
  },
  watch: {
    getnewproblem(val) {
      this.isproblem = val;
    }
  },
  created() {
    if (this.$route.params.isporblem == undefined) {
      this.isproblem = true;
    } else {
      this.isproblem = this.$route.params.isporblem;
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
    window.removeEventListener("scroll", this.handleFun);
  },
  mounted() {
    // 从本地加载已经登录的信息
    this.account = Session.getAccount();
    switch (this.isfeature) {
      case "feature":
        this.feature2();
        break;
      case "service":
        this.service2();
        break;
      case "download":
        this.download();
        break;
    }
    window.addEventListener("scroll", this.handleFun);
  },
  computed: {
    getnewproblem() {
      return this.$store.state.isproblem;
    }
  },
  methods: {
    login() {
      this.isLogin = true;
      this.$store.commit("clicklogintrue")
    },
    handleFun() {
      let Y =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop;
      if ($("#feature").offset()) {
        // var scrollH = Math.floor($('#feature').offset().top) - 260;//500
        var scrollH = Math.floor(this.$refs.feature.offsetTop) - 260; //500
      }
      if (Y >= scrollH && Y <= scrollH + 1000) {
        $(".animate1").stop();
        $(".animate1").animate(
          {
            top: "0px",
            opacity: "1"
          },
          1000
        );
      } else {
        $(".animate1").stop();
        $(".animate1").animate(
          {
            top: "100px",
            opacity: "0"
          },
          1000
        );
      }
      if (Y > scrollH + 700 && Y < scrollH + 1700) {
        $(".animate2").stop();
        $(".animate2").animate(
          {
            top: "0px",
            opacity: "1"
          },
          1000
        );
      } else {
        $(".animate2").stop();
        $(".animate2").animate(
          {
            top: "100px",
            opacity: "0"
          },
          1000
        );
      }
      if (Y > scrollH + 1400 && Y < scrollH + 2400) {
        $(".animate3").stop();
        $(".animate3").animate(
          {
            top: "0px",
            opacity: "1"
          },
          1000
        );
        $(".animate3-2").stop();
        $(".animate3-2").animate(
          {
            marginTop: "-60%",
            opacity: "1"
          },
          1000
        );
      } else {
        $(".animate3").stop();
        $(".animate3").animate(
          {
            top: "100px",
            opacity: "0"
          },
          1000
        );
        $(".animate3-2").stop();
        $(".animate3-2").animate(
          {
            marginTop: "-30%",
            opacity: "0"
          },
          1000
        );
      }
      if (Y > scrollH + 2100 && Y < scrollH + 3100) {
        $(".animate4").stop();
        $(".animate4").animate(
          {
            top: "0px",
            opacity: "1"
          },
          1000
        );
        $(".animate4-1").stop();
        $(".animate4-1").animate(
          {
            marginTop: "-60%",
            opacity: "1"
          },
          1000
        );
      } else {
        $(".animate4").stop();
        $(".animate4").animate(
          {
            top: "100px",
            opacity: "0"
          },
          1000
        );
        $(".animate4-1").stop();
        $(".animate4-1").animate(
          {
            marginTop: "-30%",
            opacity: "0"
          },
          1000
        );
      }
    },
    setTurnHome() {
      this.turnHome = true;
    },
    login() {
      // 显示账户中心登录窗口
      this.isLogin = true;
      // 监听账户中心回调消息
    },
    register(kind) {
      this.isRegister = true;
      this.$store.commit("setKindTab", kind);
      this.$store.commit("clickregistertrue");
    },
    // 下载
    downloadOne() {
      let url =
        "https://saas-assets.usoftchina.com/UsoftchinaSaasClient_setup.exe";
      let alink = document.createElement("a");
      alink.style.display = "none";
      alink.href = url; //下载地址
      // alink.download = "pic"; //文件名(自定义)
      document.body.appendChild(alink);
      alink.click();
    },
    //ele常见问题
    handleSelect() {
      this.navproblem();
    },
    //常见问题
    navproblem() {
      this.$store.commit("problemfalse");
      clearInterval(this.timer);
      this.animate(0);
    },
    home() {
      clearInterval(this.timer);
      this.animate(0);
    },
    //特色
    feature2() {
      clearInterval(this.timer);
      setTimeout(() => {
        let featH = Math.floor($("#feature").offset().top) - 70;
        this.animate(featH); //690
      }, 10);
    },
    //功能
    service2() {
      clearInterval(this.timer);
      setTimeout(() => {
        let servH = Math.floor($("#service").offset().top) - 129;
        this.animate(servH); //3530
      }, 10);
    },
    // 下载
    download() {
      // window.scrollTo(0,4190);
      clearInterval(this.timer);
      setTimeout(() => {
        let dowH = Math.floor($("#download").offset().top) - 100;
        this.animate(dowH);
      }, 10);
    },
    //添加鼠标滚轮事件，鼠标滚动的时候清除定时器，否则无法滚动
    scrollout() {
      clearInterval(this.timer);
    },
    //滚动动画封装
    animate(target) {
      clearInterval(this.timer);
      this.timer = setInterval(function () {
        var leader =
          document.documentElement.scrollTop ||
          window.pageYOffset ||
          document.body.scrollTop;
        var step = (target - leader) / 10;
        step = step > 0 ? Math.ceil(step) : Math.floor(step);
        leader = leader + step;
        $(document).scrollTop(leader);
        if (leader == target) {
          clearInterval(this.timer);
        }
      }, 5);
    },
    gohome(ev) {
      var ev = ev || window.event;
      if (ev.target.childNodes[0].data == "帮助中心") {
        return;
      } else {
        this.$store.commit("problemtrue");
      }
    },

    enter(e) {
      if (e == "tradecloud") {
        this.tradebtn = true;
      } else if (e == "financialcloud") {
        this.financialbtn = true;
      } else if (e == "makeclound") {
        this.makebtn = true;
      }
    },
    leave(e) {
      if (e == "tradecloud") {
        this.tradebtn = false;
      } else if (e == "financialcloud") {
        this.financialbtn = false;
      } else if (e == "makeclound") {
        this.makebtn = false;
      }
    }
  }
};
</script>

<style scoped>
.site-content {
  background-color: #EDF6FA;
}

.cloudsystem-wrap {
  position: relative
}

.login-btn {
  position: absolute;
  top: 72.5%;
  left: 16%;
  width: 14%;
  height: 7%;
  background: url('/static/img/loginBtn.png') center center/cover no-repeat;
}

.ts-box {
  height: 700px;
}

.animate1,
.animate2,
.animate3,
.animate4,
.animate4-1,
.animate3-2 {
  position: relative;
  opacity: 0;
  top: 100px;
}

.shut {
  cursor: pointer;
  position: absolute;
  top: 10px;
  right: 10px;
}

.navbar-inverse {
  padding: 0px;
}

/* ele常见问题 */
.el-menu-demo {
  border-bottom: 0 !important;
  padding: 0px 10px !important;
}

.el-submenu {
  padding: 0px 10px !important;
}

.el-menu-demo>>>div {
  font-size: 16px !important;
  background: #1c1f48 !important;
  border-bottom: 0 !important;
}

.el-menu-demo>>>.el-submenu__title:hover {
  background: #1c1f48 !important;
}

.el-menu-demo>>>.el-submenu__title {
  padding: 0px !important;
  height: 48px !important;
  line-height: 48px !important;
  border-bottom: 0 !important;
}

.el-menu-item:hover {
  background: #1e88f5 !important;
}

/* 体验 */
.tiyan {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 640px;
  height: 283px;
  margin-left: -320px;
  margin-top: -141px;
  z-index: 10001;
  background: white;
  padding: 24px;
  text-align: center;
  border-radius: 2px;
}

.ty-out {
  cursor: pointer;
  float: right;
}

.ty-logo {
  width: 140px;
  margin: 15px 0 50px 13px;
}

.ty-input {
  width: 330px;
  height: 40px;
  line-height: 40px;
  text-align: left;
  background: rgba(32, 53, 128, 0.01);
  border: 1px solid #d8dce8;
  border-radius: 3px;
  margin-left: 69px;
}

.ty-phone {
  margin: 8px 0;
  margin-bottom: 0;
}

.ty-phone input {
  outline: none;
  border: 0;
  height: 30px;
  font-size: 14px;
  width: 80%;
}

.ty-phone button {
  background-image: linear-gradient(-90deg,
      #007ee5 0%,
      #05b3ff 100%,
      #5533ff 100%);
  border-radius: 3px;
  color: white;
  width: 125px;
  height: 40px;
  border: 0;
}

.contact {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #059ffe;
  text-align: center;
}

.Caution {
  color: red;
  margin-left: 110px;
  font-size: 12px;
  display: inline-block;
  height: 16px;
}

.slider-1 {
  position: relative;
}

.slider-text-carousel {
  position: absolute;
  z-index: 1;
  background: transparent;
  left: 0;
  right: 0;
  bottom: 0;
  height: 23vh;
  text-align: center;
}

.slider-text-carousel p {
  font-size: 1.3vw;
  color: white;
  line-height: 5vh;
}

.el-carousel__item {
  opacity: 0;
}

.el-carousel__item.is-active.is-animating {
  opacity: 1;
  transition: opacity 1s ease-in !important;
}

.el-carousel__item.is-animating {
  opacity: 0;
  transition: opacity 1s ease-out !important;
}

#scroll {
  margin: 0;
  padding: 0;
  width: 100%;
}

.info-img {
  margin: 0;
  padding: 0;
  display: block;
  width: 100%;
  line-height: 0;
  font-size: 0;
  overflow: hidden;
}

.info-img>img {
  display: block;
  margin: 0;
  padding: 0;
  width: 100%;
  height: auto;
  vertical-align: top;
}
</style>



// WEBPACK FOOTER //
// src/components/conenter/home.vue